import envConfig from 'env.json'

export const isProduction = process.env.NODE_ENV === 'production'
export const baseURL = process.env.REACT_APP_API_URL || (isProduction ? envConfig.backendUrls.prod : envConfig.backendUrls.dev)

